import request from '@/utils/request'
// 保存评委会
export const addBidEvaluationCommittee = (data) => {
    return request.post('/api/agent/bidEvaluationCommittee/add', data)
}
// 删除评委会
export const deleteBidEvaluationCommittee = (id) => {
    return request.post('/api/agent/bidEvaluationCommittee/delete?id=' + id)
}
// 评委会详情
export const getBidEvaluationCommitteeDetail = (id) => {
    return request.get('/api/agent/bidEvaluationCommittee/detail?id=' + id)
}
//添加评委会成员
export const addBidEvaluationCommitteeExpert = (data) => {
    return request.post('/api/agent/bidEvaluationCommittee/expertAdd', data)
}
//删除评委会成员
export const deleteBidEvaluationCommitteeExpert = (expertId) => {
    return request.post('/api/agent/bidEvaluationCommittee/expertDelete?expertId=' + expertId)
}
//获取评委会成员详情
export const getBidEvaluationCommitteeExpertDetail = (expertId) => {
    return request.get('/api/agent/bidEvaluationCommittee/expertDetail?expertId=' + expertId)
}
//获取评委会成员列表
export const getBidEvaluationCommitteeExpertList = (bidEvaluationCommitteeId) => {
    return request.get('/api/agent/bidEvaluationCommittee/expertList?bidEvaluationCommitteeId=' + bidEvaluationCommitteeId)
}
//初始化评委会
export const initBidEvaluationCommittee = (projectCode) => {
    return request.get('/api/agent/bidEvaluationCommittee/init?projectCode=' + projectCode)
}
//评委会列表
export const getBidEvaluationCommitteeList = (data) => {
    return request.get('/api/agent/bidEvaluationCommittee/list', data)
}
// 获取项目详情
export const getProjectInfo = (sectionCode) => {
    return request.get('/api/common/project/info?sectionCode=' + sectionCode)
}

// 获取标段详情
export const getBidSectionInfo = (bidSectionCode) => {
    return request.get('/api/common/bid-section/info?bidSectionCode=' + bidSectionCode)
}
//专家预授权接口
export const getBidEvaluationCommitteeExpertAuthorization = (idNo) => {
    return request.get('/api/ca/expert/auth?idNo=' + idNo)
}

//查询投标流程状态
export const getBidFlowStatus = (params) => {
    return request.get('/api/bid/flow/status',  params )
}

// 查询开标是否已提交
export const getOpeningIsSubmit = (sectionCode) => {
    return request.get('/api/opening/is/submit?sectionCode=' + sectionCode)
}


